<template>
    <div class="card-content" v-if="cartItem && printFile && printMode">
        <div class="columns is-mobile is-gapless">
            <div
                class="column"
                :class="{
                    'is-two-thirds': isEditable,
                    'is-four-fifth-tablet is-three-quarter-mobile': !isEditable,
                }"
            >
                <div class="cart-item__property-list">
                    <div class="cart-item__property">
                        <span class="property__label is-size-5">{{
                            $t('checkout.cart.itemLabels.name')
                        }}</span>
                        <h3 class="property__value title is-4">
                            {{ printFile.name }}
                        </h3>
                    </div>
                    <div class="cart-item__property">
                        <span class="property__label is-size-5"
                            >{{ $t('checkout.cart.itemLabels.size') }}
                            {{ printFile.givenUnitOfLength }}</span
                        >
                        <h3 class="property__value title is-4">
                            {{
                                printFile['analysedProperties'].dimensions[
                                    'X'
                                ].toFixed(2)
                            }}
                            x
                            {{
                                printFile['analysedProperties'].dimensions[
                                    'Y'
                                ].toFixed(2)
                            }}
                            x
                            {{
                                printFile['analysedProperties'].dimensions[
                                    'Z'
                                ].toFixed(2)
                            }}
                        </h3>
                    </div>
                    <div class="cart-item__property">
                        <span class="property__label is-size-5">{{
                            $t('checkout.cart.itemLabels.printMode')
                        }}</span>
                        <h3 class="property__value title is-4 property--color">
                            <span>{{ printMode.name }}, </span
                            ><span v-if="cartItem.surfaceFinish"
                                >{{ cartItem.surfaceFinish.name }},
                            </span>
                            <span>{{ cartItem.color.name }}</span>
                        </h3>
                    </div>
                    <div class="cart-item__property property--quantity">
                        <span class="property__label is-size-5">{{
                            $t('checkout.cart.itemLabels.quantity')
                        }}</span>
                        <NumberInput
                            v-model="cartItemQuantity"
                            :minimum-value="1"
                            :id="'cart-item-quantity-' + this.cartItem._id"
                            v-if="isEditable"
                        />
                        <h3 class="property__value title is-4" v-else>
                            {{ cartItemQuantity }}
                        </h3>
                    </div>
                    <!--item-processing v-if="printModeById(printMode.id).processingSteps.length > 0" :is-editable="isEditable" :cart-item="cartItem"></item-processing-->
                    <div
                        class="cart-item__property property--attachments"
                        v-if="showAttachments"
                    >
                        <cart-item-attachments :cartItem="cartItem" />
                    </div>
                </div>
            </div>
            <div
                class="column"
                :class="{
                    'is-one-third': isEditable,
                    'is-one-fifth-tablet is-one-quarter-mobile': !isEditable,
                }"
            >
                <CartItemPreview
                    :cartItem="cartItem"
                    :is-editable="isEditable"
                    :is-legacy="isLegacy"
                />
            </div>
        </div>
    </div>
</template>

<script>
import NumberInput from '../shared/NumberInput';
import { mapGetters } from 'vuex';
import { MATERIAL_MAPPING } from '../../store/constants/material-mapping';
import { viewports } from '../../store/constants/viewports';
import SvgIcon from '../svg/SvgIcon';
import LazyLoadedImage from '../shared/LazyLoadedImage';
import CartItemPreview from './CartItemPreview';
import CartItemAttachments from './cart/CartItemAttachments';
import ItemProcessing from './cart/ItemProcessing';

export default {
    name: 'CartItem',
    components: {
        ItemProcessing,
        CartItemAttachments,
        CartItemPreview,
        LazyLoadedImage,
        SvgIcon,
        NumberInput,
    },
    data() {
        return { MATERIAL_MAPPING, viewports };
    },
    props: {
        cartItem: {
            type: Object,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
        showAttachments: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLegacy: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'printModes',
            'currentViewPort',
            'screenSize',
            'printModeById',
        ]),
        printMode() {
            if (!this.cartItem.printMode) {
                return this.$store.getters.printModeById(
                    this.cartItem.printMode.id
                );
            }
            return this.cartItem.printMode;
        },
        printFile() {
            if (!this.isLegacy) {
                return this.$store.getters.printFileById(
                    this.cartItem.model._id
                );
            }
            return this.cartItem.model;
        },
        cartItemQuantity: {
            get() {
                return this.cartItem.quantity;
            },
            async set(value) {
                if (this.isEditable) {
                    await this.$store.dispatch('updateCartItemByID', {
                        cartItemId: this.cartItem._id,
                        quantity: value,
                    });
                    await this.$store.dispatch('persistCartItemByID', {
                        cartItemId: this.cartItem._id,
                    });
                }
            },
        },
    },
    methods: {
        fetchPrintFile() {
            if (this.cartItem && !this.isLegacy) {
                this.$store.dispatch(
                    'fetchPrintFileById',
                    this.cartItem.model._id
                );
            }
        },
    },
    mounted() {
        this.fetchPrintFile();
    },
};
</script>

<style></style>
